import { AxiosResponse } from 'axios';
import {
  IUser,
  NewPasswordRequestDTO,
} from '../shared/interfaces/user-interfaces';
import api from './api';

interface IUserRegisterPayloadRequest {
  email: string;
  first_name: string;
  last_name: string;
  password: string;
  password2: string;
  group: string[];
  whatsapp: string;
  company?: number;
}

interface IUserLoginPayloadRequest {
  email: string;
  password: string;
}

interface IService {
  signUp: (data: IUserRegisterPayloadRequest) => Promise<AxiosResponse>;
  signIn: (data: IUserLoginPayloadRequest) => Promise<AxiosResponse>;
  update: (
    data: Partial<IUserRegisterPayloadRequest>,
  ) => Promise<AxiosResponse>;
  recoverPassword: (email: string) => Promise<void>;
  newPassword: (data: NewPasswordRequestDTO) => Promise<void>;
  retrieve: (id: string) => Promise<AxiosResponse<IUser>>;
}

const userService: IService = {
  signUp: data => api.post('/user/register_user', data),
  signIn: data => api.post('/user/authenticate_user', data),
  update: data => api.patch('/user/update_user', data),
  recoverPassword: email => api.post('/user/recover_password', { email }),
  newPassword: data => api.post('/user/new_password', data),
  retrieve: id => api.get(`/user/retrieve_user/${id}`),
};

export default userService;
